module.exports = __webpack_public_path__ + "static/media/step_004.24dbec04.jpeg";